module.exports = __webpack_public_path__ + "static/media/MonstrousOrigins.af1131df.jpg";